import {GetAnalysisPipelineStep, GetAnalysisStepData} from 'analysis-tool/AnalysisTypes';
import {PipelineStepDataKind} from 'graphql-client/__generated/graphqlGlobalTypes';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';

export default function getOutputStepDataForDataFrame(
  step: GetAnalysisPipelineStep,
  dataFrameId: string
): GetAnalysisStepData | null {
  return (
    step.outputStepDatas.find(
      (stepData) =>
        stepData.kind === PipelineStepDataKind.DATASET &&
        stepData.dataFrames.some((dataFrame) => dataFrame.id === dataFrameId)
    ) ?? null
  );
}

export function getOutputDataReferenceForDataFrame(
  step: GetAnalysisPipelineStep,
  dataFrameId: string
): {
  stepDataName: string;
  stepDataIndex: number;
} | null {
  const stepData = getOutputStepDataForDataFrame(step, dataFrameId);
  if (stepData == null) {
    return null;
  }

  const stepDataIndex = stepData.dataFrames.findIndex((dataFrame) => dataFrame.id === dataFrameId);
  return stepDataIndex >= 0
    ? {
        stepDataName: stepData.name,
        stepDataIndex,
      }
    : null;
}

export function getOutputDataReferenceForScratchFile(
  step: GetAnalysisPipelineStep,
  scratchFileId: string
): {
  stepDataName: string;
  stepDataIndex: number;
} | null {
  for (const stepData of step.outputStepDatas) {
    if (stepData.kind !== PipelineStepDataKind.FILE) {
      continue;
    }
    const stepDataIndex = stepData.scratchFiles.findIndex(
      (scratchFile) => !isInaccessible(scratchFile) && scratchFile.id === scratchFileId
    );
    if (stepDataIndex >= 0) {
      return {stepDataName: stepData.name, stepDataIndex};
    }
  }
  return null;
}

export function getOutputStepDataForChart(
  step: GetAnalysisPipelineStep,
  chartId: string
): GetAnalysisStepData | null {
  return (
    step.outputStepDatas.find(
      (stepData) =>
        stepData.kind === PipelineStepDataKind.CHART &&
        stepData.charts.some((chart) => (!isInaccessible(chart) ? chart.id === chartId : false))
    ) ?? null
  );
}
